import React from 'react'
import { CollezioniPageConfig } from '../configuration'
import VisibilitySensor from '../VisibilitySensor'
import Container from '../Container'
import styles from './Collezione.module.sass'
import Vimeo from "@u-wave/react-vimeo";
import AssignId from '../AssignId'

export default function Collezione() {
    const showTitle = false;
    return (
        <Container>
            <div className={styles.root}>
                <AssignId
                    absolute
                    y='-120px'
                    yMobile='-80px'
                    id={CollezioniPageConfig.id}
                />
                <h1 className={`${styles.h1} scroll-fadein`}>{CollezioniPageConfig.title}</h1>
                <VisibilitySensor index={7} />
                <div className={`${styles.iframeWrap} scroll-fadein-late`} >
                    <Vimeo
                        className='styles.iframe'
                        video={CollezioniPageConfig.videoId}
                        responsive
                        paused
                        color='154C03'
                        showTitle={showTitle}
                        showByline={showTitle}
                        showPortrait={showTitle}
                    />
                </div>
            </div>
        </Container>
    )
}